import { base64UrlToBuffer, bufferToBase64Url } from 'theSource/utils';
import {
  AuthenticationDatatDto,
  AuthenticationOptionsResponseDto,
} from '../types';

export const mapToCredentialRequestOptions = (
  data: AuthenticationOptionsResponseDto
): CredentialRequestOptions => ({
  publicKey: {
    ...data,
    challenge: base64UrlToBuffer(data.challenge),
    allowCredentials: data.allowCredentials.map((credential) => ({
      type: credential.type,
      id: base64UrlToBuffer(credential.id),
    })),
  },
});

export const mapToAuthenticationData = (
  credential: PublicKeyCredential
): AuthenticationDatatDto => {
  const assertionResponse =
    credential.response as AuthenticatorAssertionResponse;

  const authenticationData: AuthenticationDatatDto = {
    type: credential.type,
    id: credential.id,
    rawId: bufferToBase64Url(credential.rawId),
    response: {
      authenticatorData: bufferToBase64Url(assertionResponse.authenticatorData),
      clientDataJSON: bufferToBase64Url(assertionResponse.clientDataJSON),
      signature: bufferToBase64Url(assertionResponse.signature),
    },
  };

  return authenticationData;
};
